import { AsistenteImportacion } from "../../components/importacion/AsistenteImportacion";
import { type CampoImportacion, importarClientes } from "../../lib/consola-api";

/**
 * Importación de clientes desde planilla (ADR 0016).
 *
 * Los cuatro pasos —elegir, mapear, previsualizar, confirmar— viven en
 * `AsistenteImportacion`, compartido con la de productos. Acá quedan solo las
 * dos cosas propias de clientes: qué campos tiene la planilla y a qué endpoint
 * va.
 */
export function ImportarClientes({
  campos,
  onCerrar,
  onImportado,
}: {
  campos: readonly CampoImportacion[];
  onCerrar: () => void;
  onImportado: () => Promise<void>;
}) {
  return (
    <AsistenteImportacion
      titulo="Importar clientes"
      sustantivo="cliente"
      campos={campos}
      importar={(filas, simular) => importarClientes(filas, simular)}
      onCerrar={onCerrar}
      onImportado={onImportado}
    />
  );
}
